import axios  from 'axios';
import { Link, useParams } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
// import { Box, Paper } from "@material-ui/core";

// import { renderText } from "../common/DisplayComponent";
import CopyToClipboard from 'react-copy-to-clipboard';
import { Button, Table, Toast } from 'react-bootstrap';
import baseUrl from '../../../../services/api';
import { useNavigate} from "react-router-dom"
import { Pencil, PencilFill, Share, Trash } from 'react-bootstrap-icons';
import SideBar from './Sidebar';
import { ToastContainer, toast } from 'react-toastify';
import { CopyAll } from '@mui/icons-material';
const FormView = () => {
const { cfd } = useParams();
const session_token = sessionStorage.getItem("token");
const [show, setShow] = useState(false);
const navigate = useNavigate();
const handleClose = () => setShow(false);
const handleShow = () => setShow(true);
const [data, setData] = useState(null);
var item_value = sessionStorage.getItem('name');
const com_id = sessionStorage.getItem("com_id");
const shareableLink = `${baseUrl}/formview/${cfd}`;
const session_role = sessionStorage.getItem("role");
const session_type = sessionStorage.getItem("form_type");
const [formtype, setFormtype] = useState();
useEffect(() => {
  console.log("Type",session_type);
    const fetchData = async () => {
      axios.defaults.headers.common = {
        Authorization: `Bearer ${session_token}`,
      };
      try {
        const response = await axios.get(`${baseUrl}/getSample/${cfd}`);
        setData(response?.data);
        console.log('data', response?.data);
        console.log('dodododdodod ....', cfd);
      } catch (error) {
        console.error('Error fetching view data:', error);
      }
    };
  
    fetchData(); 
    
    
    // Call the asynchronous function
  

    console.log('coming session id', com_id);
    axios
  .get(`${baseUrl}/company/${com_id}`)
  .then((value) => {
    console.log("companyyyyyyy ", value.data);
   
    setFormtype(value.data[0]?.type);
  })
  .catch((reason) => {
    console.log("reason comppppppppppp", reason.response.data);
    if (reason.response.data.includes("Token")) {
      navigate("/login");
    }
  });

  }, [cfd, baseUrl, session_token]);

  const handleShareClick = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: 'Share Link',
          text: 'Check out this link!',
          url: shareableLink,
        });
      } else {
        // Fallback for browsers that do not support the Share API
        // Implement your custom sharing logic here
        const success = copyToClipboard(shareableLink);

        if (success) {
          toast.success('Link copied to clipboard!, you can share this link');
        } else {
          alert.error('Copy link manually: ' + shareableLink);
        }
      }
    } catch (error) {
      console.error('Error sharing link:', error);
    }
  };

  const copyToClipboard = (text) => {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
      return true;
    } catch (err) {
      console.error('Unable to copy to clipboard:', err);
      return false;
    } finally {
      document.body.removeChild(textArea);
    }
  };
 

  return (
    <div class="content">
    <div class='sidebar'>
      <SideBar />
    </div>



    <section class="stuff">
      
     <div class="form2">
<div class='row' style={{marginLeft: 30, padding: 10}}>
    <div class='col-md-2'><Button variant="secondary"><Link style={{textDecoration: 'none', color:'white', paddingTop: 5}} to={session_role === 'admin' ? '/member' : '/form'}>Dashboard</Link></Button> </div>
    <div class='col-md-4'>
    
    </div>
    
<div  class='col-md-6'>
copy URL
<CopyAll onClick={handleShareClick} type='button' size={30} />
</div>
<hr/>
</div>
<p>{data === null ? (
  
 <>
 <h1> No data available Or something Wrong</h1>
 </>
  
  ): (<>
  <div class='table'>
        <Table responsive striped>
          <thead>
            <tr>
              <th>Attributes</th>

              <th>Values</th>
             
            </tr>
          </thead>
         {formtype == 'coffees'? (

          <tbody>
            <tr>
              <td>Full Name</td>
              <td>{item_value} </td>
            </tr>
            <tr>
              <td>Sample ID</td>
              <td>{data[0].id} </td>
            </tr>
            <tr>
              <td>Roast</td>
              <td>{data[0].roast} </td>
            </tr>
            <tr>
              <td>Aroma Level</td>
              <td>{data[0].aromalevel} </td>
            </tr>
            <tr>
              <td>Aroma Dry Intensity</td>
              <td>{data[0].aromadryintensity} </td>
            </tr>
            <tr>
              <td>Aroma Dry Comment</td>
              <td>{data[0].aromadrycomment} </td>
            </tr>
            <tr>
              <td>Aroma Break Intensity</td>
              <td>{data[0].aromabreakintensity} </td>
            </tr>
            <tr>
              <td>Aroma Break Comment</td>
              <td>{data[0].aromabreakcomment} </td>
            </tr>
            <tr>
              <td>Aroma Score</td>
              <td>{data[0].aromascore} </td>
            </tr>
            <tr>
              <td>Flavour Level</td>
              <td>{data[0].flavourlevel} </td>
            </tr>
            <tr>
              <td>Flavour Intensity</td>
              <td>{data[0].flavourintensity} </td>
            </tr>
            <tr>
              <td>Flavour Score</td>
              <td>{data[0].flavourscore} </td>
            </tr>
            <tr>
              <td>After Test Level</td>
              <td>{data[0].aftertestlevel} </td>
            </tr>
            <tr>
              <td>After Test Duration</td>
              <td>{data[0].aftertestduration} </td>
            </tr>
            <tr>
              <td>After Test Score</td>
              <td>{data[0].aftertestscore} </td>
            </tr>

            <tr>
              <td>Acidity Level</td>
              <td>{data[0].aciditylevel} </td>
            </tr>
            <tr>
              <td>Acidity Intensity</td>
              <td>{data[0].acidityintensity} </td>
            </tr>
            <tr>
              <td>Acidity Character</td>
              <td>{data[0].aciditycharacter} </td>
            </tr>
            <tr>
              <td>Acidity Score</td>
              <td>{data[0].acidityscore} </td>
            </tr>


            <tr>
              <td>Mouth Feel Level</td>
              <td>{data[0].mouthfeellevel} </td>
            </tr>
            <tr>
              <td>Mouth Feel Body</td>
              <td>{data[0].mouthfeelbody} </td>
            </tr>
            <tr>
              <td>Mouth Feel Character</td>
              <td>{data[0].mouthfeelcharacter} </td>
            </tr>
            <tr>
              <td>Mouth Feel Score</td>
              <td>{data[0].mouthfeelscore} </td>
            </tr>
            <tr>
              <td>Uniqueness Level</td>
              <td>{data[0].uniquenesslevel} </td>
            </tr>
            <tr>
              <td>Uniqueness Score</td>
              <td>{data[0].uniquenessscore} </td>
            </tr>
            <tr>
              <td>Balance Level</td>
              <td>{data[0].balancelevel} </td>
            </tr>
            <tr>
              <td>Balance Score</td>
              <td>{data[0].balancescore} </td>
            </tr>
            
            <tr>
              <td>Uniformity Score</td>
              <td>{data[0].uniformityscore} </td>
            </tr>
            
            <tr>
              <td>Clean Cup Score</td>
              <td>{data[0].cleancupscore} </td>
            </tr>
            
            <tr>
              <td>Sweetness Intensity</td>
              <td>{data[0].sweetnessintensity} </td>
            </tr>
            <tr>
              <td>Sweetness Score</td>
              <td>{data[0].sweetnessscore} </td>
            </tr>
            <tr>
              <td>Aging</td>
              <td>{data[0].aging} </td>
            </tr>
            <tr>
              <td>Ferment Profile</td>
              <td>{data[0].fermentprofile} </td>
            </tr>
            <tr>
              <td>Moisture Content</td>
              <td>{data[0].moisturecontent} </td>
            </tr>
            <tr>
              <td>Density</td>
              <td>{data[0].density} </td>
            </tr>
            <tr>
              <td>Aw</td>
              <td>{data[0].aw} </td>
            </tr>
            <tr>
              <td>Quaker Count</td>
              <td>{data[0].quakercount} </td>
            </tr>
            <tr>
              <td>Defects</td>
              <td>{data[0].defectsc} </td>
            </tr>
           
            <tr>
              <td>Defects Note</td>
              <td>{data[0].defectsnote} </td>
            </tr>
            <tr>
              <td>Notes Dry</td>
              <td>{data[0].notesdry} </td>
            </tr>
            <tr>
              <td>Notes Break</td>
              <td>{data[0].notesbreak} </td>
            </tr>
            <tr>
              <td>Profile</td>
              <td>{data[0].profile} </td>
            </tr>
            <tr>
              <td>Notes Negative</td>
              <td>{data[0].notesnegative} </td>
            </tr>
            <tr>
              <td>Total Score</td>
              <td>{data[0].totalscore} </td>
            </tr>
            <tr>
              <td>Total Defects</td>
              <td>{data[0].totaldefects} </td>
            </tr>
            <tr>
              <td>Final Score</td>
              <td>{data[0].finalscore} </td>
            </tr>

          </tbody>
         ):(
          <>
         <tbody>
          <tr><td colSpan={1}><span>Godkännande av Approval shipping sample</span></td><td></td></tr>
          <tr>
            <td>Datum</td>
            <td>{data[0].ssa_date}</td>
          </tr>
          <tr>
            <td>Lättning</td>
            <td>{data[0].relief}</td>
          </tr>
          <tr>
            <td>Leverantör</td>
            <td>{data[0].supplier}</td>
          </tr>
          <tr>
            <td>kontrakts Nr</td>
            <td>{data[0].contractnumber}</td>
          </tr>
          <tr>
            <td>Betyg</td>
            <td>{data[0].grade}</td>
          </tr>
          <tr>
            <td>Skala</td>
            <td>{data[0].scale}</td>
          </tr>
          <tr>
            <td>Kommentar</td>
            <td>{data[0].ssa_comment}</td>
          </tr>
          <tr>
            <td>Kaffe nr</td>
            <td>{data[0].coffeenumber}</td>
          </tr>
          <tr>
            <td>Kaffe Typ</td>
            <td>{data[0].coffeetype}</td>
          </tr>
          <tr>
            <td>Ekologiskt kaffe</td>
            <td>{data[0].organiccoffee + ''}</td>
          </tr>
          <tr>
            <td>Godkänt skeppningsprov</td>
            <td>{data[0].passedshippingtest + ''}</td>
          </tr>
          <tr>
            <td>Signatur</td>
            <td>{data[0].ssa_signature
}</td>
          </tr>
          <tr><td colSpan={1}><span>Mottagningskontroll</span></td></tr>
          <tr>
            <td>Datum</td>
            <td>{data[0].rc_date
}</td>
          </tr>
          <tr>
            <td>Container identitet</td>
            <td>{data[0].containeridentity==''?"Yes":data[0].containeridentity}</td>
          </tr>
          <tr>
            <td>Plomberingsnummer</td>
            <td>{data[0].sealingnumber==""?"Yes":data[0].sealingnumber}</td>
          </tr>
          <tr>
            <td>Container utan skador</td>
            <td>{data[0].nocontainerdamage==''?"Yes":data[0].nocontainerdamage}</td>
          </tr>
          <tr>
            <td>Normal lukt och utseende</td>
            <td>{data[0].normalsmellandappearance==""?"Yes":data[0].normalsmellandappearance}</td>
          </tr>
          <tr>
            <td>Ankomstvikt</td>
            <td>{data[0].arrivalweight}</td>
          </tr>
          <tr>
            <td>Rensas till silo</td>
            <td>{data[0].clearedtosilo}</td>
          </tr>
          <tr>
            <td>Vikt rensning</td>
            <td>{data[0].weightclearance
}</td>
          </tr>
          <tr>
            <td>Slutvikt:t</td>
            <td>{data[0].finalweight
}</td>
          </tr>
          <tr>
            <td>Signatur</td>
            <td>{data[0].rc_signature}</td>
          </tr>
          <tr>
            <td>Hinknummer</td>
            <td>{data[0].hinknumber}</td>
          </tr>
          <tr><td colSpan={1}><span>Analys av prover</span></td></tr>
          <tr>
            <td>Datum</td>
            <td>{data[0].as_date}</td>
          </tr>
          <tr>
            <td>Kommentar</td>
            <td>{data[0].as_comment}</td>
          </tr>
          <tr>
            <td>Godkänd analys</td>
            <td>{data[0].approvedanalysis + ''}</td>
          </tr>
          <tr>
            <td>Signatur</td>
            <td>{data[0].as_signature}</td>
          </tr>
         </tbody>
          </>
         )}
          
        </Table>

      </div>
</>)}</p>
    
      </div>  
      </section>
      </div>
   
  );
};

export default FormView;
